import React, { useState } from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Paper,
  Alert,
  Link,
  Avatar,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';


const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      
      // Add delay to simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Basic validation for demo purposes
      if (!username || !password) {
        throw new Error('Please enter username and password');
      }
      
      // Simulate successful login for specific test accounts
      if (username === 'patient1' && password === 'password123') {
        login(username, password);
        navigate('/patient'); // Redirect to patient home
        return;
      }
      
      if (username === 'caregiver1' && password === 'password123') {
        login(username, password);
        navigate('/patient'); // Redirect to patient view for caregiver
        return;
      }
      
      if (username === 'family1' && password === 'password123') {
        login(username, password);
        navigate('/patient'); // Redirect to patient view for family
        return;
      }
      
      if (username === 'TBAdmin' && password === 'password123') {
        login(username, password);
        navigate('/dashboard'); // Redirect to dashboard for admin
        return;
      }
      
      // If no matching credentials
      throw new Error('Invalid username or password');
      
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Button 
          startIcon={<ArrowBackIcon />} 
          sx={{ alignSelf: 'flex-start', mb: 2 }}
          onClick={() => navigate('/')}
        >
          Back to Home
        </Button>
        
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        
        <Typography component="h1" variant="h4" sx={{ mb: 2 }}>
          TBX Mobile
        </Typography>
        <Typography align="center" component="h2" variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
          Tuberculosis Treatment Adherence Monitoring
        </Typography>
        
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ py: 1.5 }}
              disabled={loading}
            >
              Login
            </Button>
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Link href="/dashboard/login" underline="hover">
                TB Admin Login
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 